var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.order_base)?_c('div',{staticClass:"logistics boxs"},[_c('div',{staticClass:"tit"},[_vm._v("物流跟踪")]),_c('div',{staticClass:"infoStep empty"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }